
export class StepQueryResultContainer {
    queryTime: number;
    stepCounters: Record<string, number> = {};
    arcDurations: ArcDuration[] = [];
    instanceDuration: FmDuration = new FmDuration();

    constructor(
        queryTime?: number,
        stepCounters?: Record<string, number>,
        arcDurations?: ArcDuration[],
        instanceDuration?: FmDuration
    ) {
        if (queryTime) {
            this.queryTime = queryTime;
        }
        if (stepCounters) {
            this.stepCounters = stepCounters;
        }
        if (arcDurations) {
            this.arcDurations = arcDurations;
        }
        if (instanceDuration) {
            this.instanceDuration = instanceDuration;
        }
    }
}

export class FmDuration {
    avgDurationMs: number = 0;
    minDurationMs: number = 0;
    maxDurationMs: number = 0;

    constructor(avgDurationMs?: number, minDurationMs?: number, maxDurationMs?: number) {
        if (avgDurationMs) {
            this.avgDurationMs = avgDurationMs;
        }
        if (minDurationMs) {
            this.minDurationMs = minDurationMs;
        }
        if (maxDurationMs) {
            this.maxDurationMs = maxDurationMs;
        }
    }
}

export class ArcDuration extends FmDuration {
    parentStepCode: string;
    childStepCode: string;

    constructor(
        avgDurationMs?: number,
        minDurationMs?: number,
        maxDurationMs?: number,
        parentStepCode?: string,
        childStepCode?: string
    ) {
        super(avgDurationMs, minDurationMs, maxDurationMs);
        if (parentStepCode) {
            this.parentStepCode = parentStepCode;
        }
        if (childStepCode) {
            this.childStepCode = childStepCode;
        }
    }
}
